<template>
    <div class="userList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <!-- <el-form-item v-if="level == 0">
                    <el-input
                        size
                        clearable
                        v-model="searchForm.agent_name"
                        placeholder="请输入一级代理姓名"
                    ></el-input>
                </el-form-item> -->
                <!-- <el-form-item v-if="level == 0">
                    <el-input
                        size
                        clearable
                        v-model="searchForm.agent_phone"
                        placeholder="请输入一级代理账号"
                    ></el-input>
                </el-form-item> -->
                <el-form-item>
                    <el-input size clearable v-model="searchForm.phone" placeholder="请输入代理账号"></el-input>
                </el-form-item>
				<el-form-item>
				    <el-input size clearable v-model="searchForm.agent_no" placeholder="请输入代理编号"></el-input>
				</el-form-item>
                <el-form-item v-if="level == 0 || level == 1">
                    <el-input
                            size
                            clearable
                            v-model="searchForm.real_name"
                            placeholder="请输入代理姓名"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="searchForm.auth_status"
                        clearable
                        placeholder="请选择实名认证状态"
                    >
                        <el-option label="已认证" value="1"></el-option>
                        <el-option label="未认证" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="level == 0 || level == 1">
                    <el-input
                        size
                        clearable
                        v-model="searchForm.parent_real_phone"
                        placeholder="请输入推荐人手机号"
                    ></el-input>
                </el-form-item>
                <el-form-item v-if="level == 0">
                    <el-input size clearable v-model="searchForm.level" placeholder="请输入层级"></el-input>
                </el-form-item>
                <el-form-item v-if="level == 0">
                    <el-input size clearable v-model="searchForm.code" placeholder="邀请码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="searchForm.team_classification"
                        clearable
                        placeholder="请选择所属分类"
                    >
						<el-option label="个人" value="1"></el-option>
						<el-option label="企业" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                	<el-select size="medium" v-model="searchForm.is_center" filterable clearable style="width:100%"
                		placeholder="请选择是否运营中心">
                		<el-option label="否" value="1"></el-option>
                		<el-option label="是" value="2"></el-option>
                	</el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="searchForm.mode_type"
                        clearable
                        placeholder="请选择展业模式"
                    >
                		<el-option label="档位模式" value="1"></el-option>
                		<el-option label="自定义模式" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="注册开始日期"
                        end-placeholder="注册结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="handleSearch(searchForm)"
                    >查询</el-button>
					<el-button
					    size="medium"
					    type="primary"
					    icon="el-icon-search"
					    style="font-size: 12px;"
					    @click="frozenDialog()"
					>批量冻结</el-button>
					<el-button size="medium" type="primary" icon="el-icon-plus" @click="frozenAddStock">批量导入冻结</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <div style="margin-bottom: 20px;">
               <el-button 
                    v-if="level >0 && level <5 && is_company ==2"
                    size="small"
                    type="primary"
                    icon="el-icon-plus"
                    @click="handleAddAgent"
                >企业代理签约</el-button>
               <el-button v-if="level >= 1" 
                    size="small"
                    type="primary"
                    icon="el-icon-plus"
                    @click="addAgentDialog"
                >个人代理签约</el-button>
            </div>
            <el-table :data="userTable" size="mini" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
				<el-table-column
				      type="selection"
				      width="55">
				    </el-table-column>
                <!-- 用户ID -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    prop="id"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 用户账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    label="代理账号"
                    min-width="120"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.phone | desMobile" placement="top">
                      <p>{{ scope.row.phone }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 代理商编号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_no"
                    label="代理商编号"
                    min-width="150"
                ></el-table-column>
                <!-- 真实姓名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="real_name"
                    label="真实姓名"
                    min-width="120"
                ></el-table-column>
                <!-- 层级-字段名待修改 -->
				
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="level"
                    label="层级"
                    min-width="80"
                    v-if="level == 0"
                >
					<template slot-scope="scope">
						{{scope.row.level}}
					</template>
				</el-table-column>
                <el-table-column
                    align="center"
                    header-align="center"
                    prop="is_center_text"
                    label="是否运营中心"
                    min-width="150"
                >
                </el-table-column>
                
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="is_company_text"
                    label="代理商类型"
                    min-width="120"
                >
                </el-table-column>
				
				
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="is_loop_back_text"
				    label="是否开通循环返"
					min-width="120"
				>
				</el-table-column>
				
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="mode_type_text"
				    label="展业模式"
				    min-width="120"
				>
				</el-table-column>
                <!-- 邀请码 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="code"
                    label="邀请码"
                    min-width="120"
                ></el-table-column>
                <!-- 昵称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="nickname"
                    label="昵称"
                    min-width="120"
                ></el-table-column>
                <!-- 实名认证 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="auth_status"
                    label="实名认证"
                    min-width="120"
                    :formatter="authStatus"
                ></el-table-column>
                <!-- 推荐人姓名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="parent_name"
                    label="推荐人姓名"
                    min-width="120"
                    v-if="level == 0 || level == 1"
                ></el-table-column>
                <!-- 公司昵称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="parent_nickname"
                    label="公司名称"
                    min-width="120"
                    v-if="level == 0"
                ></el-table-column>
                <!-- 推荐人账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="parent_phone"
                    label="推荐人账号"
                    min-width="120"
                    v-if="level == 0 || level == 1"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.parent_phone" placement="top">
                      <p>{{ scope.row.parent_phone}}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!--&lt;!&ndash; 一级代理名称 &ndash;&gt;-->
                <!--<el-table-column-->
                <!--    header-align="center"-->
                <!--    align="center"-->
                <!--    prop="agent_name"-->
                <!--    label="一级代理名称"-->
                <!--    min-width="120"-->
                <!--&gt;</el-table-column>-->
                <!--&lt;!&ndash; 一级代理账号 &ndash;&gt;-->
                <!--<el-table-column-->
                <!--    header-align="center"-->
                <!--    align="center"-->
                <!--    prop="agent_phone"-->
                <!--    label="一级代理账号"-->
                <!--    min-width="120"-->
                <!--&gt;</el-table-column>-->
                <!-- 所属分类 -->
<!--                <el-table-column
                    header-align="center"
                    align="center"
                    prop="team_classification"
                    label="所属分类"
                    min-width="120"
                    v-if="level == 0"
                ></el-table-column> -->
                <!-- 注册时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="注册时间"
                    min-width="150"
                ></el-table-column>
                <!-- 最近登陆 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="login_last_time"
                    label="最近登陆"
                    min-width="150"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <el-button @click="handleChangeModeInfo(scope.row)" type="text" size="small" v-if="level < 1 && scope.row.level == 2">修改展业模式</el-button>
						<el-button @click="handleEditBankInfo(scope.row)" type="text" size="small" v-if="scope.row.is_company==2 && level < 1">结算信息修改</el-button>
                        <el-button @click="handleInfo(scope.row)" type="text" size="small">详情</el-button>
                        <el-button @click="BlockedDialog(scope.row)" type="text" size="small" v-if="level ==0 || level == 1">冻结</el-button>
                        <el-button type="text" size="small" v-if="scope.row.level == 2">
							<span @click="settlement(scope.row)" v-if="scope.row.is_edit_rate == 0">开通自由配置</span>
							<span  v-else style="color:#C0C4CC">已开通自由配置</span>
						</el-button>
						
						
						<div v-if="level > 1">
							<el-button type="text" size="small" v-if="scope.row.parent_loop_back == 1">
								<span @click="loopReversal(scope.row)" v-if="scope.row.is_loop_back == 0">开通循环返</span>
								<span  v-else style="color:#C0C4CC">已开通循环返</span>
							</el-button>
						</div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
                style="text-align: center"
            ></el-pagination>
        </el-card>
        <!-- 添加代理 -->
        <add-agent v-if="agentIsShow" :agentIsShow="agentIsShow" @agentClose="agentClose"></add-agent>

		<!-- 结算信息修改 -->
		<bank-info v-if="bankDetail.isShow" :info="bankDetail" @infoClose="handleCloseBank"></bank-info>
        <!-- 修改展业模式 -->
        <mode-type v-if="changeMode" :info="modeDetail" @infoClose="handleCloseMode"></mode-type>
		<!-- 冻结用户 -->
		<add-sign
		    v-if="signIsShow"
		    :signIsShow="signIsShow"
		    :agentNo="agentNo"
		    @signClose="signClose"
		></add-sign>
        <!-- 冻结用户 -->
        <blocked-user
            v-if="blockedIsShow"
            :blockedIsShow="blockedIsShow"
            :userId="userId"
            @blockedClose="blockedClose"
        ></blocked-user>
		<!-- 批量冻结 -->
		<el-dialog
		    ref="blocked"
		    :visible="frozenState"
			@close="handleClose"
		    :close-on-click-modal="false"
		    title="冻结用户"
		>
		    <el-card class="box-card" shadow="hover">
		        <el-form :model="frozenForm" label-position="top">
		            <el-form-item label="冻结方式">
		                <el-select size v-model="frozenForm.type" clearable placeholder="请选择冻结方式">
		                    <el-option label="提现冻结" value="1"></el-option>
		                    <el-option label="登陆冻结" value="2"></el-option>
		                </el-select>
		            </el-form-item>
		            <el-form-item label="冻结原因备注">
		                <el-input type="textarea" v-model="frozenForm.reason"></el-input>
		            </el-form-item>
		            <el-form-item style="margin-top:20px">
		                <el-button
		                    type="primary"
		                    :loading="frozenLoading"
		                    style="font-size: 12px;"
		                    @click="handleBlocked(frozenForm)"
		                >确认冻结</el-button>
		            </el-form-item>
					
					<el-collapse-transition>
					  <el-form-item v-if="statusIsShow">
						<div class="titleTip">数据状态</div>
						<div class="tips">共计数据:{{dataStatus.total}}条</div>
						<div class="tips">成功数据:{{dataStatus.successTotal}}条</div>
						<div class="tips">失败数据:{{dataStatus.defeatTotal}}条</div>
					  </el-form-item>
					</el-collapse-transition>
		        </el-form>
		    </el-card>
			</el-form>
		</el-dialog>
		
		<!--//导入批量冻结-->
		<frozen-stock-tools
		  v-if="frozen"
		  :toolsIsShow="frozen"
		  @toolsClose="frozenToolsClose"
		></frozen-stock-tools>
    </div>
</template>

<script>
import addAgent from './UM_addAgent';
import addSign from './UM_addSign';
import blockedUser from './UM_blockedUser';
import modeType from './changeAgent_modeType.vue';// 展业模式
import bankInfo from '../../agentManagement/components/editBankInfo.vue'; // 结算信息修改
	import frozenStockTools from './frozen_stockTools';
export default {
    name: "UM_userList",
    data() {
        return {
            bankDetail: {
                isShow: false,
                row: {}
            },
            isEdit: 1,
            teamList: [],
            agentIsShow: false,
            signIsShow: false,
            blockedIsShow: false,
            userId: null,
            agentNo: null,
            rangeDate: '',
            searchForm: {
                page: 1,
                limit: 10,
                is_center:'',
                agent_name: '', //一级代理姓名
                agent_phone: '',    //一级代理账号
                real_name: '',   //用户真实姓名
                phone: '',   //用户账号
				agent_no: '',
                auth_status: '', //实名认证状态
                parent_real_name: '', // 推荐人真实姓名
                parent_real_phone: '', //推荐人手机号
                level: '', //层级字段
                code:'', //邀请码
                team_classification: '', //所属分类
                create_start_time: '', //用户注册开始时间
                create_end_time: '' ,//用户注册结束时间
                mode_type:'' // 展业模式
            },
            userTable: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: false,
            level: null,
			//批量冻结
			multipleSelection:[],
			frozenState:false,
			frozenForm:{
				type: '2',
				reason: ''
			},
			frozenLoading:false,
			statusIsShow:false,
			dataStatus: {
			  total: '', //总数
			},
			frozen:false,
            changeMode:false,
            modeDetail:{}
        }
    },
    mounted() {
        this.level = sessionStorage.getItem('level')
        this.is_company = sessionStorage.getItem('is_company')
        this.getTeam();//获取所属分类
        this.getData({
            page: 1,
            limit: 10
        });
    },
    components: {
        addAgent,
        addSign,
		bankInfo, // 结算信息修改
        blockedUser,
		frozenStockTools,
        modeType
    },
    methods: {
		//开通循环反
		loopReversal(row){
			this.$confirm('确认开通该代理商循环反的功能,开通后不能关闭?', ' ', {
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消',
			    type: 'warning',
			}).then(() => {
				this.$api.post('user/open_loop_back', { user_id: row.id }, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.getData(this.searchForm);
					} else {
						this.$message.error(res.msg);
			        }
			    })
			}).catch(() => { });
		},
		//开通自由配置结算
		settlement(row){
			this.$confirm('确认开通该代理商自由配置结算价的功能,开通后不能关闭?', ' ', {
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消',
			    type: 'warning',
			}).then(() => {
				this.$api.post('user/open_free_settlement', { user_id: row.id }, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.getData(this.searchForm);
					} else {
						this.$message.error(res.msg);
			        }
			    })
			}).catch(() => { });
		},
		//批量冻结
		frozenAddStock() {
		  this.frozen = true;
		},
		frozenToolsClose(ref) { //关闭导入
		  this.frozen = false;
		  if (ref) { //重载表格
		    this.getData({
		        page: 1,
		        limit: this.page.pageSize,
		        name: this.searchFrom.name,
		    	title:this.searchFrom.title,
		    	up_code:this.searchFrom.up_code
		    })
		  }
		},
		//勾选数据
		handleSelectionChange(val){
			this.multipleSelection = val;
		},
		
		//批量冻结
		frozenDialog(){
			this.statusIsShow = false;
			this.dataStatus = {};
			if(this.multipleSelection.length != 0){
				this.frozenState = true;
			}else{
				this.$message.error("请先勾选数据");
			}
		},
		handleClose() { //关闭结算信息修改
		    this.frozenState= false;
		    this.frozenForm = {
				type: '2',
				reason: ''
			};
			let params = this.searchForm;
			this.getData(params);
		},
		//确定批量冻结
		handleBlocked() { //确认冻结
		    let that = this;
			let data = {
				user_list:[],
				type:this.frozenForm.type,
				reason:this.frozenForm.reason,
			};
			var arr = [];
			this.multipleSelection.map(res=>{
				arr.push(res.id)
			})
			data.user_list = arr.join(',');
		    this.frozenLoading = true; //防重复
		    this.$api.post('user/freezeBatch', data, res => {
				console.log(res)
		        if (res.code == 0) {
		            this.$message({
		                type: 'success',
		                message: res.msg,
		                duration: 2000,
		            })
					this.statusIsShow = true;
					this.dataStatus = res.data;
					let params = this.searchForm;
					this.getData(params);
					this.frozenLoading = false;
		        } else {
		            this.$message.error(res.msg);
		            this.frozenLoading = false;
		        }
		    })
		},
        handleSearch(searchForm) { //搜索
            this.currentPage = 1;
            searchForm.page = 1;
            this.getData(searchForm);
        },
		handleEditBankInfo(row) { // 结算信息修改
		    this.bankDetail.isShow = true;
		    this.bankDetail.row = row;
		},
        // 修改展业模式
        handleChangeModeInfo(row){
            this.modeDetail = row
            this.changeMode = true
        },
        // 关闭修改展业模式
        handleCloseMode(ref){
            this.changeMode = false
            this.modeDetail = {}
            if (ref) {
                let params = this.searchForm;
                this.getData(params);
            }
            
        },
		handleCloseBank(ref) { //关闭结算信息修改
		    this.bankDetail.isShow = false;
		    this.bankDetail.row = {};
		    if (ref) {
		        let params = this.searchForm;
		        this.getData(params);
		    }
		},
        addAgentDialog() { //添加代理弹窗
            this.agentIsShow = true;
        },
		addSignDialog(row) { //添加代理弹窗
			if (row.agent_no == null) {
				this.$message.error("请先实名认证");
			} else {
				this.agentNo = row.agent_no; //用户id
				this.signIsShow = true;
			}
        },
        handleAddAgent() { // 添加签约代理
            this.$router.push({ path: '/addUser' })
        },
        BlockedDialog(row) { //冻结弹窗
            this.userId = row.id; //用户id
            this.blockedIsShow = true;
        },
        handleInfo(row) { //详情
            this.$router.push({ path: '/userInfo', query: { id: row.id } });
        },
        //分页
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        getData(params) { //初始化数据
            this.loading = true;
            this.$api.post("user/list", params, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.total = data.count; //总数
                    this.userTable = data.list;
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        getTeam() { //获取所属分类
            this.$api.post('team_classification/team_classification', {}, res => {
                if (res.code == 0) {
                    this.teamList = res.data
                }
            })
        },
        authStatus(row) { //表格内容转换
            let auth_status;
            switch (row.auth_status) {
                case 1:
                    auth_status = "已实名";
                    break;
                case 0:
                    auth_status = "未实名";
                    break;
            }
            return auth_status;
        },
        agentClose(ref) { //关闭添加代理弹窗
            this.agentIsShow = false;
            if (ref) {
                this.getData({
                    page: this.currentPage,
                    limit: this.pageSize,
                });
            }
        },
		signClose(ref) { //关闭添加代理弹窗
		    this.signIsShow = false;
		    if (ref) {
		        this.getData({
		            page: this.currentPage,
		            limit: this.pageSize,
		        });
		    }
		},
        blockedClose(ref) { //关闭冻结用户弹窗
            this.blockedIsShow = false;
            if (ref) {
                this.getData({
                    page: this.currentPage,
                    limit: this.pageSize,
                });
            }
        },
        pickerChange(DateArr) { //时间选择器
            this.searchForm.create_start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.create_end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        }
    }
};
</script>

<style lang="scss" scoped>
.userList {
}
</style>
